import axios from 'axios'
import usersApi from '@/api/usersApi'
import { getItem } from '@/api/defaultApi'

const state = () => ({
  // Объекты для хранения измененных данных после отправки на сервер
  updatedUser: {},
  updatedProfile: {},
  // Объект в который приходят данные из api и хранится состояние полей страницы
  userForUpdate: {},
  userUpdateValidation: {
    password: {
      type: null,
      message: ''
    }
  },
  userUpdateIsLoading: true,
  // состояния модальных окон
  modals_active: {
    success: false,
    error: false
  },
  familyMemberUpdateModal: {
    active: false,
    member: null
  },
  familyMemberCreateModal: {
    active: false,
    member: {
      name: '',
      surname: '',
      patronymic: '',
      kinship: { id: null, name: '' },
      birth_at: '',
      phone: ''
    }
  },
  documentUpdateModal: {
    active: false,
    document: null
  },
  documentCreateModal: {
    active: false,
    document: {
      type: { id: null, name: '' },
      citizenship: '',
      serial: '',
      number: '',
      issued_by: '',
      code: '',
      date_at: ''
    }
  },
  educationUpdateModal: {
    active: false,
    education: null
  },
  educationCreateModal: {
    active: false,
    education: {
      type: { id: null, name: '' },
      start_at: '',
      end_at: '',
      date_at: '',
      speciality: { id: null, name: '' },
      organization: '',
      document: { id: null, name: '' }
    }
  },
  // Стейт деталки пользователя (так-как данная страница не имеет экшенов и мутаций, только геттеры)
  // В дальнейшем можно вынести в отдельный модуль
  userForDetail: {},
  userDetailIsLoading: true,
  userParentDepartment: {},
  userParentDepartmentHead: {}
})

const getters = {
  updatedUser: state => state.updatedUser,
  userForUpdate: state => state.userForUpdate,
  userUpdateValidation: state => state.userUpdateValidation,
  userUpdatePageModals: state => state.modals_active,
  userUpdateIsLoading: state => state.userUpdateIsLoading,
  userFamilyMemberUpdateModal: state => state.familyMemberUpdateModal,
  userFamilyMemberCreateModal: state => state.familyMemberCreateModal,
  userDocumentUpdateModal: state => state.documentUpdateModal,
  userDocumentCreateModal: state => state.documentCreateModal,
  userEducationUpdateModal: state => state.educationUpdateModal,
  userEducationCreateModal: state => state.educationCreateModal,
  // детальная страница пользователя
  userDetailIsLoading: state => state.userDetailIsLoading,
  userForDetail: state => state.userForDetail
}

const mutations = {
  // запись в стейт пользователя для редактирования и деталки
  SET_USER_DETAIL: (state, user) => {
    state.userForUpdate = user
    state.userForDetail = user
  },
  SET_USER_LOADING: (state, bool) => {
    state.userUpdateIsLoading = bool
    state.userDetailIsLoading = bool
  },
  SET_USER_UPDATE_VALIDATION: (state, response) => {
    if (response?.password) {
      state.userUpdateValidation.password.message = response.password[0]
      state.userUpdateValidation.password.type = 'error'
    }
  },
  '[userUpdate] CLEAR_USER_VALIDATION': (state, inputName) => {
    switch (inputName) {
      case 'password':
        state.userUpdateValidation.password = { type: null, message: '' }
        break
      default:
        break
    }
  },
  // переключение флагов для лоадера
  SET_USER_UPDATE_IS_LOADING: state => {
    state.userUpdateIsLoading = true
  },
  SET_USER_DETAIL_IS_LOADING: state => {
    state.userDetailIsLoading = true
  },
  // запись в стейт отредактированных полей на странице "релактировать пользователя"
  UPDATE_USER_SHOW_SUCCESS: (state) => {
    state.modals_active.success = true
  },
  SET_USER_PHONE: (state, phone) => {
    state.userForUpdate.phone = phone
  },
  SET_USER_EMAIL: (state, email) => {
    state.userForUpdate.email = email
  },
  SET_USER_PASSWORD: (state, password) => {
    state.userForUpdate.password = password
  },
  ADD_USER_ROLE: (state, role) => {
    state.userForUpdate.roles.push(role)
  },
  REMOVE_USER_ROLE: (state, role) => {
    state.userForUpdate.roles = state.userForUpdate.roles.filter(item => {
      return item.id !== role.id
    })
  },
  SET_USER_NAME: (state, name) => {
    state.userForUpdate.profile.name = name
  },
  SET_USER_SURNAME: (state, surname) => {
    state.userForUpdate.profile.surname = surname
  },
  SET_USER_PATRONYMIC: (state, patronymic) => {
    state.userForUpdate.profile.patronymic = patronymic
  },
  SET_USER_BIRTH_DATE: (state, date) => {
    state.userForUpdate.profile.birth_at = date
  },
  SET_USER_BIRTH_PLACE: (state, place) => {
    state.userForUpdate.profile.birth_place = place
  },
  SET_USER_CORP_PHONE: (state, phone) => {
    state.userForUpdate.profile.corp_phone = phone
  },
  SET_USER_WORK_PHONE: (state, phone) => {
    state.userForUpdate.profile.work_phone = phone
  },
  SET_USER_WORK_PHONE_APPEND: (state, phone) => {
    state.userForUpdate.profile.work_phone_append = phone
  },
  TOGGLE_USER_OFFICIAL_FLAG: (state) => {
    const flag = state.userForUpdate.profile.is_official
    if (flag) {
      state.userForUpdate.profile.is_official = 0
    } else {
      state.userForUpdate.profile.is_official = 1
    }
  },
  SET_USER_STATUS: (state, status) => {
    state.userForUpdate.status_id = status.id
    state.userForUpdate.status = {
      id: status.id,
      name: status.name
    }
  },
  SET_USER_DEPARTMENT: (state, department) => {
    state.userForUpdate.department_id = department.id
    state.userForUpdate.department = {
      id: department.id,
      name: department.name
    }
  },
  SET_USER_POSITION: (state, position) => {
    state.userForUpdate.position_id = position.id
    state.userForUpdate.position = {
      id: position.id,
      name: position.name
    }
  },
  SET_USER_EMPLOYMENT: (state, employment) => {
    state.userForUpdate.employment_id = employment.id
    state.userForUpdate.employment = {
      id: employment.id,
      name: employment.name
    }
  },
  SET_USER_SCHEDULE: (state, schedule) => {
    state.userForUpdate.schedule_id = schedule.id
    state.userForUpdate.schedule = {
      id: schedule.id,
      name: schedule.name
    }
  },
  SET_USER_EMPLOYMENT_DATE: (state, date) => {
    state.userForUpdate.profile.employment_at = date
  },
  SET_USER_INN: (state, inn) => {
    state.userForUpdate.profile.inn = inn
  },
  SET_USER_SNILS: (state, snils) => {
    state.userForUpdate.profile.snils = snils
  },
  // показ и скрытие модалок
  UPDATE_USER_SHOW_ERROR: (state) => {
    state.modals_active.error = true
  },
  UPDATE_USER_CLOSE_MODAL: (state) => {
    state.modals_active.success = false
    state.modals_active.error = false
  },
  SHOW_USER_FAMILY_MEMBER_UPDATE_MODAL: (state, member) => {
    state.familyMemberUpdateModal.active = true
    state.familyMemberUpdateModal.member = {
      ...member,
      kinship: member.kinship ? { id: member.kinship.id, name: member.kinship.name } : { id: null, name: '' }
    }
  },
  CLOSE_USER_FAMILY_MEMBER_UPDATE_MODAL: (state) => {
    state.familyMemberUpdateModal.active = false
    state.familyMemberUpdateModal.member = null
  },
  UPDATE_USER_FAMILY_MEMBER_NAME: (state, name) => {
    state.familyMemberUpdateModal.member.name = name
  },
  UPDATE_USER_FAMILY_MEMBER_SURNAME: (state, surname) => {
    state.familyMemberUpdateModal.member.surname = surname
  },
  UPDATE_USER_FAMILY_MEMBER_PATRONYMIC: (state, patronymic) => {
    state.familyMemberUpdateModal.member.patronymic = patronymic
  },
  UPDATE_USER_FAMILY_MEMBER_KINSHIP: (state, kinship) => {
    state.familyMemberUpdateModal.member.kinship_id = kinship.id
    state.familyMemberUpdateModal.member.kinship = kinship
  },
  UPDATE_USER_FAMILY_MEMBER_BIRTHDATE: (state, date) => {
    state.familyMemberUpdateModal.member.birth_at = date
  },
  UPDATE_USER_FAMILY_MEMBER_PHONE: (state, phone) => {
    state.familyMemberUpdateModal.member.phone = phone
  },
  SHOW_USER_FAMILY_MEMBER_CREATE_MODAL: (state) => {
    state.familyMemberCreateModal.active = true
  },
  CLOSE_USER_FAMILY_MEMBER_CREATE_MODAL: (state) => {
    state.familyMemberCreateModal.active = false

    state.familyMemberCreateModal.member.name = ''
    state.familyMemberCreateModal.member.surname = ''
    state.familyMemberCreateModal.member.patronymic = ''
    state.familyMemberCreateModal.member.kinship = { id: null, name: '' }
    state.familyMemberCreateModal.member.birth_at = ''
    state.familyMemberCreateModal.member.phone = ''
  },
  SET_USER_NEW_FAMILY_MEMBER_NAME: (state, name) => {
    state.familyMemberCreateModal.member.name = name
  },
  SET_USER_NEW_FAMILY_MEMBER_SURNAME: (state, surname) => {
    state.familyMemberCreateModal.member.surname = surname
  },
  SET_USER_NEW_FAMILY_MEMBER_PATRONYMIC: (state, patronymic) => {
    state.familyMemberCreateModal.member.patronymic = patronymic
  },
  SET_USER_NEW_FAMILY_MEMBER_KINSHIP: (state, kinship) => {
    state.familyMemberCreateModal.member.kinship = kinship
  },
  SET_USER_NEW_FAMILY_MEMBER_BIRTHDATE: (state, date) => {
    state.familyMemberCreateModal.member.birth_at = date
  },
  SET_USER_NEW_FAMILY_MEMBER_PHONE: (state, phone) => {
    state.familyMemberCreateModal.member.phone = phone
  },
  SHOW_USER_DOCUMENT_UPDATE_MODAL: (state, document) => {
    state.documentUpdateModal.active = true
    state.documentUpdateModal.document = {
      ...document,
      type: document.type ? { id: document.type.id, name: document.type.name } : { id: null, name: '' }
    }
  },
  CLOSE_USER_DOCUMENT_UPDATE_MODAL: (state) => {
    state.documentUpdateModal.active = false
    state.documentUpdateModal.document = null
  },
  UPDATE_USER_DOCUMENT_TYPE: (state, type) => {
    state.documentUpdateModal.document.type = type
  },
  UPDATE_USER_DOCUMENT_CITIZENSHIP: (state, citizenship) => {
    state.documentUpdateModal.document.citizenship = citizenship
  },
  UPDATE_USER_DOCUMENT_SERIAL: (state, serial) => {
    state.documentUpdateModal.document.serial = serial
  },
  UPDATE_USER_DOCUMENT_NUMBER: (state, number) => {
    state.documentUpdateModal.document.number = number
  },
  UPDATE_USER_DOCUMENT_ISSUED_BY: (state, issuedBy) => {
    state.documentUpdateModal.document.issued_by = issuedBy
  },
  UPDATE_USER_DOCUMENT_CODE: (state, code) => {
    state.documentUpdateModal.document.code = code
  },
  UPDATE_USER_DOCUMENT_DATE_AT: (state, date) => {
    state.documentUpdateModal.document.date_at = date
  },
  SHOW_USER_DOCUMENT_CREATE_MODAL: (state) => {
    state.documentCreateModal.active = true
  },
  CLOSE_USER_DOCUMENT_CREATE_MODAL: (state) => {
    state.documentCreateModal.active = false

    state.documentCreateModal.document.type = { id: null, name: '' }
    state.documentCreateModal.document.citizenship = ''
    state.documentCreateModal.document.serial = ''
    state.documentCreateModal.document.number = ''
    state.documentCreateModal.document.issued_by = ''
    state.documentCreateModal.document.code = ''
    state.documentCreateModal.document.date_at = ''
  },
  SET_USER_NEW_DOCUMENT_TYPE: (state, type) => {
    state.documentCreateModal.document.type = type
  },
  SET_USER_NEW_DOCUMENT_CITIZENSHIP: (state, citizenship) => {
    state.documentCreateModal.document.citizenship = citizenship
  },
  SET_USER_NEW_DOCUMENT_SERIAL: (state, serial) => {
    state.documentCreateModal.document.serial = serial
  },
  SET_USER_NEW_DOCUMENT_NUMBER: (state, number) => {
    state.documentCreateModal.document.number = number
  },
  SET_USER_NEW_DOCUMENT_ISSUED_BY: (state, issuedBy) => {
    state.documentCreateModal.document.issued_by = issuedBy
  },
  SET_USER_NEW_DOCUMENT_CODE: (state, code) => {
    state.documentCreateModal.document.code = code
  },
  SET_USER_NEW_DOCUMENT_DATE_AT: (state, date) => {
    state.documentCreateModal.document.date_at = date
  },
  SHOW_USER_EDUCATION_UPDATE_MODAL: (state, education) => {
    console.log('SHOW_USER_EDUCATION_UPDATE_MODAL ', education)
    console.log('education', education)

    state.educationUpdateModal.active = true
    state.educationUpdateModal.education = {
      ...education,
      type: education.type ? { id: education.type.id, name: education.type.name } : { id: null, name: '' },
      speciality: education.speciality ? { id: education.speciality.id, name: education.speciality.name } : { id: null, name: '' },
      document: education.document ? { id: education.document.id, name: education.document.name } : { id: null, name: '' }
    }
  },
  CLOSE_USER_EDUCATION_UPDATE_MODAL: (state) => {
    state.educationUpdateModal.active = false
    state.educationUpdateModal.education = null
  },
  UPDATE_USER_EDUCATION_TYPE: (state, type) => {
    state.educationUpdateModal.education.type = type
  },
  UPDATE_USER_EDUCATION_ORGANIZATION: (state, organization) => {
    state.educationUpdateModal.education.organization = organization
  },
  UPDATE_USER_EDUCATION_DATE_START: (state, date) => {
    state.educationUpdateModal.education.start_at = date
  },
  UPDATE_USER_EDUCATION_DATE_END: (state, date) => {
    state.educationUpdateModal.education.end_at = date
  },
  UPDATE_USER_EDUCATION_SPECIALITY: (state, speciality) => {
    state.educationUpdateModal.education.speciality = speciality
  },
  UPDATE_USER_EDUCATION_DOCUMENT: (state, document) => {
    state.educationUpdateModal.education.document = document
  },
  UPDATE_USER_EDUCATION_DATE_AT: (state, date) => {
    state.educationUpdateModal.education.date_at = date
  },
  SHOW_USER_EDUCATION_CREATE_MODAL: (state) => {
    state.educationCreateModal.active = true
  },
  CLOSE_USER_EDUCATION_CREATE_MODAL: (state) => {
    state.educationCreateModal.active = false
    state.educationCreateModal.education.type = { id: null, name: '' }
    state.educationCreateModal.education.start_at = ''
    state.educationCreateModal.education.end_at = ''
    state.educationCreateModal.education.date_at = ''
    state.educationCreateModal.education.speciality = { id: null, name: '' }
    state.educationCreateModal.education.organization = ''
    state.educationCreateModal.education.document = { id: null, name: '' }
  },
  SET_USER_NEW_EDUCATION_TYPE: (state, type) => {
    state.educationCreateModal.education.type = type
  },
  SET_USER_NEW_EDUCATION_ORGANIZATION: (state, organization) => {
    state.educationCreateModal.education.organization = organization
  },
  SET_USER_NEW_EDUCATION_DATE_START: (state, date) => {
    state.educationCreateModal.education.start_at = date
  },
  SET_USER_NEW_EDUCATION_DATE_END: (state, date) => {
    state.educationCreateModal.education.end_at = date
  },
  SET_USER_NEW_EDUCATION_SPECIALITY: (state, speciality) => {
    state.educationCreateModal.education.speciality = speciality
  },
  SET_USER_NEW_EDUCATION_DOCUMENT: (state, document) => {
    state.educationCreateModal.education.document = document
  },
  SET_USER_NEW_EDUCATION_DATE_AT: (state, date) => {
    console.log('date', date)
    state.educationCreateModal.education.date_at = date
  }
}

const actions = {
  async getUserById ({ commit, state }, { userId, withDepartments = true }) {
    commit('SET_USER_LOADING', true)

    try {
      const response = await usersApi.getSingle(userId)
      const user = response.data.data

      const departmentId = user.department ? user.department.id : null
      const subDepartmentIds = user.sub_departments ? user.sub_departments.map(item => item.id) : null
      const documentIds = user.documents ? user.documents.map(item => item.id) : null
      const familyIds = user.families ? user.families.map(item => item.id) : null
      const educationIds = user.educations ? user.educations.map(item => item.id) : null
      let department = {}
      let sub_departments = []
      const documents = []
      const families = []
      const educations = []

      if (withDepartments) {
        department = await loadUserDepartmentInfo(departmentId, user)
        sub_departments = await loadUserSubDepartmentInfo(subDepartmentIds, user)
      }

      await loadUserInfo('documents', documents, documentIds, 'type')
      await loadUserInfo('families', families, familyIds, 'kinship')
      await loadUserInfo('education', educations, educationIds, 'type,form,document,speciality')

      const extendedUser = {
        ...user,
        phone: user.phone ? user.phone : '',
        email: user.email ? user.email : '',
        roles: user.roles ? user.roles : [],
        isOnline: user.difference_auth_at && user.difference_auth_at < 300,
        department,
        sub_departments,
        documents,
        educations,
        families,
        profile: user.profile ? {
          ...user.profile,
          name: user.profile.name ? user.profile.name : '',
          surname: user.profile.surname ? user.profile.surname : '',
          patronymic: user.profile.patronymic ? user.profile.patronymic : '',
          full_name: user.profile.full_name ? user.profile.full_name : '',
          corp_phone: user.profile.corp_phone ? user.profile.corp_phone : '',
          work_phone: user.profile.work_phone ? user.profile.work_phone : '',
          work_phone_append: user.profile.work_phone_append ? user.profile.work_phone_append : ''
        } : {}
      }

      commit('SET_USER_DETAIL', extendedUser)
    } catch (err) {
      console.log('ошибка получения пользователя', err)
    } finally {
      commit('SET_USER_LOADING', false)
    }

    async function loadUserDepartmentInfo (departmentId, user) {
      // отдел, где юзер числится сотрудником
      if (departmentId) {
        try {
          const response = await getItem('departments', departmentId, {
            expand: 'head,users'
          })
          return setDepartment(response, user)
        } catch (error) {
          console.log(error)
        }
      }

      return {}
    }
    async function loadUserSubDepartmentInfo (subDepartmentIds, user) {
      const subDepartments = []

      // подчиненные отделы
      if (subDepartmentIds?.length) {
        try {
          const response = await axios.all(subDepartmentIds.map(id => getItem('departments', id, {
            expand: 'head,users'
          })))
          for (const res of response) {
            subDepartments.push(await setDepartment(res, user))
          }
        } catch (error) {
          console.log(error)
        }
      }

      return subDepartments
    }
    async function loadUserInfo (url, array, arrayIds, expand) {
      if (arrayIds?.length) {
        const response = await axios.all(arrayIds.map(id => getItem(url, id, { expand })))
        response.forEach(res => array.push(res.data.data))
      }
    }
    async function setDepartment (response, user) {
      const department = {
        ...response.data.data,
        users: response.data?.data?.users
      }

      const headId = response.data.data.head_id
      await loadDepartmentHead(headId, department, user)
      // await loadDepartmentUsers(response.data?.data?.users, department)

      return department
    }
    async function loadDepartmentHead (headId, department, user) {
      if (headId) {
        if (headId === user.id) {
          department.head = user
        } else {
          try {
            const response = await getItem('users', headId, {
              expand: 'head,users'
            })
            department.head = response.data.data
          } catch (err) {
            console.log('ошибка получения главы отдела', err.response)
          }
        }
      }
    }
    // async function loadDepartmentUsers (users, department) {
    //   if (!users?.length) return
    //
    //   const userIds = users.map(user => user.id)
    //   const usersResponse = await axios.all(userIds.map(id => getItem('users', id, { expand: 'profile,avatar' })))
    //   usersResponse.forEach(res => department.users.push(res.data.data))
    // }
  },
  updateUserInfo ({ commit, state, rootState }, data) {
    const profileParams = {
      id: data.profileId,
      updateData: {
        name: state.userForUpdate?.profile?.name,
        surname: state.userForUpdate?.profile?.surname,
        patronymic: state.userForUpdate?.profile?.patronymic,
        birth_at: state.userForUpdate?.profile?.birth_at,
        birth_place: state.userForUpdate?.profile?.birth_place,
        corp_phone: state.userForUpdate?.profile?.corp_phone,
        work_phone: state.userForUpdate?.profile?.work_phone,
        work_phone_append: state.userForUpdate?.profile?.work_phone_append,
        employment_at: state.userForUpdate?.profile?.employment_at,
        inn: state.userForUpdate?.profile?.inn,
        snils: state.userForUpdate?.profile?.snils,
        is_official: state.userForUpdate?.profile?.is_official
      }
    }

    const profileUpdate = usersApi.putProfile(profileParams)

    const userParams = {
      id: data.userId,
      updateData: {
        roles: state.userForUpdate.roles.map(role => role.id),
        email: state.userForUpdate.email,
        phone: state.userForUpdate.phone,
        password: state.userForUpdate.password,
        password_confirmation: state.userForUpdate.password,
        status_id: state.userForUpdate.status_id,
        department_id: state.userForUpdate.department_id,
        position_id: state.userForUpdate.position_id,
        employment_id: state.userForUpdate.employment_id,
        schedule_id: state.userForUpdate.schedule_id
      }
    }
    const userUpdate = usersApi.putUser(userParams)

    if (!rootState.userRoles.users.actionAccess) {
      usersApi.putProfile(userParams).then(response => {
        this.dispatch('showUserUpdateSuccessModal')
        // если данные изменены у текущего пользователя обновляем его выводимые данные
        const currentUserId = rootState.appData.currentUser.id
        if (+data.userId === +currentUserId) {
          usersApi.getCurrentUser().then(response => {
            commit('GET_CURRENT_USER_DATA', response.data.data)
          })
        }
      }).catch(error => {
        console.log('Ошибка:', error.response)
        this.dispatch('showUserUpdateErrorModal')
      })
    } else {
      axios.all([userUpdate, profileUpdate]).then(response => {
        this.dispatch('showUserUpdateSuccessModal')
        // если данные изменены у текущего пользователя обновляем его выводимые данные
        const currentUserId = rootState.appData.currentUser.id
        if (+data.userId === +currentUserId) {
          usersApi.getCurrentUser().then(response => {
            commit('GET_CURRENT_USER_DATA', response.data.data)
          })
        }
      }).catch(error => {
        console.log('Ошибка:', error.response)
        commit('SET_USER_UPDATE_VALIDATION', error.response.data.validation)
        this.dispatch('showUserUpdateErrorModal')
      })
    }
  },
  updateUserAvatar ({ state, commit }, avatar) {
    const formData = new FormData()
    formData.append('avatar', avatar)
    const params = {
      userId: state.userForUpdate.id,
      formData: formData
    }

    usersApi.postAvatar(params).then((response) => {
      console.log('новое фото пользователя загружено')
    }).catch(error => {
      console.log('Ошибка:' + error.response.data)
    })
  },
  // удаление пользователя
  deleteUserFromUserDetail ({ commit }, userId) {
    usersApi.deleteUser(userId).then(response => {
      console.log('Пользователь успешно удален')
    }).catch(error => {
      console.log('Ошибка удаления пользователя:' + error)
    })
  },
  // показ модалки на странице "редактировать пользователя"
  showUserUpdateSuccessModal ({ commit }) {
    commit('UPDATE_USER_SHOW_SUCCESS')
  },
  showUserUpdateErrorModal ({ commit }) {
    commit('UPDATE_USER_SHOW_ERROR')
  },
  // закрытие модалок на странице "редактировать пользователя"
  closeUserUpdateModal ({ commit }) {
    commit('UPDATE_USER_CLOSE_MODAL')
  },
  // установка значения полей на странице "редактировать пользователя"
  updateUserName ({ commit }, value) {
    commit('SET_USER_NAME', value)
  },
  updateUserSurname ({ commit }, value) {
    commit('SET_USER_SURNAME', value)
  },
  updateUserPatronymic ({ commit }, value) {
    commit('SET_USER_PATRONYMIC', value)
  },
  updateUserPhone ({ commit }, value) {
    commit('SET_USER_PHONE', value)
  },
  updateUserEmail ({ commit }, value) {
    commit('SET_USER_EMAIL', value)
  },
  updateUserPassword ({ commit }, value) {
    commit('SET_USER_PASSWORD', value)
  },
  addUserRole ({ commit }, role) {
    commit('ADD_USER_ROLE', role)
  },
  removeUserRole ({ commit }, role) {
    commit('REMOVE_USER_ROLE', role)
  },
  updateUserBirthDate ({ commit }, value) {
    commit('SET_USER_BIRTH_DATE', value)
  },
  updateUserBirthPlace ({ commit }, place) {
    commit('SET_USER_BIRTH_PLACE', place)
  },
  updateUserCorpPhone ({ commit }, value) {
    commit('SET_USER_CORP_PHONE', value)
  },
  updateUserWorkPhone ({ commit }, value) {
    commit('SET_USER_WORK_PHONE', value)
  },
  updateUserWorkPhoneAppend ({ commit }, value) {
    commit('SET_USER_WORK_PHONE_APPEND', value)
  },
  updateUserOfficialFlag ({ commit }) {
    commit('TOGGLE_USER_OFFICIAL_FLAG')
  },
  updateUserStatus ({ commit }, value) {
    commit('SET_USER_STATUS', value) // на входе объект нового статуса (id и name)
  },
  updateUserDepartment ({ commit }, value) {
    commit('SET_USER_DEPARTMENT', value) // на входе объект нового подразделения (id и name)
  },
  updateUserPosition ({ commit }, value) {
    commit('SET_USER_POSITION', value) // на входе объект новой должности (id и name)
  },
  updateUserEmployment ({ commit }, value) {
    commit('SET_USER_EMPLOYMENT', value) // на входе объект нового вида занятости (id и name)
  },
  updateUserSchedule ({ commit }, value) {
    commit('SET_USER_SCHEDULE', value) // на входе объект нового графика (id и name)
  },
  updateUserEmploymentDate ({ commit }, value) {
    commit('SET_USER_EMPLOYMENT_DATE', value)
  },
  updateUserInn ({ commit }, inn) {
    commit('SET_USER_INN', inn)
  },
  updateUserSnils ({ commit }, snils) {
    commit('SET_USER_SNILS', snils)
  },
  showUserFamilyMemberUpdateModal ({ commit }, member) {
    commit('SHOW_USER_FAMILY_MEMBER_UPDATE_MODAL', member)
  },
  closeUserFamilyMemberUpdateModal ({ commit }) {
    commit('CLOSE_USER_FAMILY_MEMBER_UPDATE_MODAL')
  },
  updateUserFamilyMemberName ({ commit }, name) {
    commit('UPDATE_USER_FAMILY_MEMBER_NAME', name)
  },
  updateUserFamilyMemberSurname ({ commit }, surname) {
    commit('UPDATE_USER_FAMILY_MEMBER_SURNAME', surname)
  },
  updateUserFamilyMemberPatronymic ({ commit }, patronymic) {
    commit('UPDATE_USER_FAMILY_MEMBER_PATRONYMIC', patronymic)
  },
  updateUserFamilyMemberKinship ({ commit }, kinship) {
    commit('UPDATE_USER_FAMILY_MEMBER_KINSHIP', kinship)
  },
  updateUserFamilyMemberBirthDate ({ commit }, date) {
    commit('UPDATE_USER_FAMILY_MEMBER_BIRTHDATE', date)
  },
  updateUserFamilyMemberPhone ({ commit }, phone) {
    commit('UPDATE_USER_FAMILY_MEMBER_PHONE', phone)
  },
  updateUserFamilyMember ({ commit, state }, memberId) {
    const userId = state.userForUpdate.id
    const params = {
      memberId: memberId,
      memberData: {
        name: state.familyMemberUpdateModal.member.name,
        surname: state.familyMemberUpdateModal.member.surname,
        patronymic: state.familyMemberUpdateModal.member.patronymic,
        kinship_id: state.familyMemberUpdateModal.member.kinship_id,
        birth_at: state.familyMemberUpdateModal.member.birth_at,
        phone: state.familyMemberUpdateModal.member.phone
      }
    }

    usersApi.putFamilies(params).then(response => {
      commit('CLOSE_USER_FAMILY_MEMBER_UPDATE_MODAL')
      this.dispatch('getUserById', { userId })
    }).catch(error => {
      console.log('ошибка редактирования члена семьи', error.response)
    })
  },
  showUserFamilyMemberCreateModal ({ commit }) {
    commit('SHOW_USER_FAMILY_MEMBER_CREATE_MODAL')
  },
  closeUserFamilyMemberCreateModal ({ commit }) {
    commit('CLOSE_USER_FAMILY_MEMBER_CREATE_MODAL')
  },
  setUserNewFamilyMemberName ({ commit }, name) {
    commit('SET_USER_NEW_FAMILY_MEMBER_NAME', name)
  },
  setUserNewFamilyMemberSurname ({ commit }, surname) {
    commit('SET_USER_NEW_FAMILY_MEMBER_SURNAME', surname)
  },
  setUserNewFamilyMemberPatronymic ({ commit }, patronymic) {
    commit('SET_USER_NEW_FAMILY_MEMBER_PATRONYMIC', patronymic)
  },
  setUserNewFamilyMemberKinship ({ commit }, kinship) {
    commit('SET_USER_NEW_FAMILY_MEMBER_KINSHIP', kinship)
  },
  setUserNewFamilyMemberBirthDate ({ commit }, date) {
    commit('SET_USER_NEW_FAMILY_MEMBER_BIRTHDATE', date)
  },
  setUserNewFamilyMemberPhone ({ commit }, phone) {
    commit('SET_USER_NEW_FAMILY_MEMBER_PHONE', phone)
  },
  createUserFamilyMember ({ commit, state }) {
    const userId = state.userForUpdate.id
    const memberData = {
      user_id: userId,
      name: state.familyMemberCreateModal.member.name,
      surname: state.familyMemberCreateModal.member.surname,
      patronymic: state.familyMemberCreateModal.member.patronymic,
      kinship_id: state.familyMemberCreateModal.member.kinship.id,
      birth_at: state.familyMemberCreateModal.member.birth_at,
      phone: state.familyMemberCreateModal.member.phone
    }

    usersApi.postFamilies(memberData).then(response => {
      commit('CLOSE_USER_FAMILY_MEMBER_CREATE_MODAL')
      this.dispatch('getUserById', { userId })
    }).catch(error => {
      console.log('ошибка создания члена семьи', error.response)
    })
  },
  removeUserFamilyMember ({ commit, state }, memberId) {
    const userId = state.userForUpdate.id

    usersApi.deleteFamilies(memberId).then(response => {
      console.log('член семьи успешно удален')
      this.dispatch('getUserById', { userId })
    }).catch(error => {
      console.log('ошибка удаления члена семьи', error.response)
    })
  },
  showUserDocumentUpdateModal ({ commit }, document) {
    commit('SHOW_USER_DOCUMENT_UPDATE_MODAL', document)
  },
  closeUserDocumentUpdateModal ({ commit }) {
    commit('CLOSE_USER_DOCUMENT_UPDATE_MODAL')
  },
  updateUserDocumentType ({ commit }, type) {
    commit('UPDATE_USER_DOCUMENT_TYPE', type)
  },
  updateUserDocumentCitizenship ({ commit }, citizenship) {
    commit('UPDATE_USER_DOCUMENT_CITIZENSHIP', citizenship)
  },
  updateUserDocumentSerial ({ commit }, serial) {
    commit('UPDATE_USER_DOCUMENT_SERIAL', serial)
  },
  updateUserDocumentNumber ({ commit }, number) {
    commit('UPDATE_USER_DOCUMENT_NUMBER', number)
  },
  updateUserDocumentIssuedBy ({ commit }, issuedBy) {
    commit('UPDATE_USER_DOCUMENT_ISSUED_BY', issuedBy)
  },
  updateUserDocumentCode ({ commit }, code) {
    commit('UPDATE_USER_DOCUMENT_CODE', code)
  },
  updateUserDocumentDateAt ({ commit }, date) {
    commit('UPDATE_USER_DOCUMENT_DATE_AT', date)
  },
  updateUserDocument ({ commit, state }, documentId) {
    const userId = state.userForUpdate.id
    const params = {
      id: documentId,
      updateData: {
        user_id: userId,
        type_id: state.documentUpdateModal.document.type.id,
        citizenship: state.documentUpdateModal.document.citizenship,
        serial: state.documentUpdateModal.document.serial,
        number: state.documentUpdateModal.document.number,
        issued_by: state.documentUpdateModal.document.issued_by,
        code: state.documentUpdateModal.document.code,
        date_at: state.documentUpdateModal.document.date_at
      }
    }

    usersApi.putDocument(params).then(response => {
      commit('CLOSE_USER_DOCUMENT_UPDATE_MODAL')
      this.dispatch('getUserById', { userId })
    }).catch(error => {
      console.log('ошибка редактирования документа', error.response)
    })
  },
  showUserDocumentCreateModal ({ commit }) {
    commit('SHOW_USER_DOCUMENT_CREATE_MODAL')
  },
  closeUserDocumentCreateModal ({ commit }) {
    commit('CLOSE_USER_DOCUMENT_CREATE_MODAL')
  },
  setUserNewDocumentType ({ commit }, type) {
    commit('SET_USER_NEW_DOCUMENT_TYPE', type)
  },
  setUserNewDocumentCitizenship ({ commit }, citizenship) {
    commit('SET_USER_NEW_DOCUMENT_CITIZENSHIP', citizenship)
  },
  setUserNewDocumentSerial ({ commit }, serial) {
    commit('SET_USER_NEW_DOCUMENT_SERIAL', serial)
  },
  setUserNewDocumentNumber ({ commit }, number) {
    commit('SET_USER_NEW_DOCUMENT_NUMBER', number)
  },
  setUserNewDocumentIssuedBy ({ commit }, issuedBy) {
    commit('SET_USER_NEW_DOCUMENT_ISSUED_BY', issuedBy)
  },
  setUserNewDocumentCode ({ commit }, code) {
    commit('SET_USER_NEW_DOCUMENT_CODE', code)
  },
  setUserNewDocumentDateAt ({ commit }, date) {
    commit('SET_USER_NEW_DOCUMENT_DATE_AT', date)
  },
  createUserDocument ({ commit, state }) {
    const userId = state.userForUpdate.id

    const postData = {
      user_id: userId,
      type_id: state.documentCreateModal.document.type.id,
      citizenship: state.documentCreateModal.document.citizenship,
      serial: state.documentCreateModal.document.serial,
      number: state.documentCreateModal.document.number,
      issued_by: state.documentCreateModal.document.issued_by,
      code: state.documentCreateModal.document.code,
      date_at: state.documentCreateModal.document.date_at
    }

    usersApi.postDocument(postData).then(() => {
      commit('CLOSE_USER_DOCUMENT_CREATE_MODAL')
      this.dispatch('getUserById', { userId })
    }).catch(error => {
      console.log('ошибка создания документа', error.response)
    })
  },
  removeUserDocument ({ commit, state }, documentId) {
    const userId = state.userForUpdate.id

    usersApi.deleteDocument(documentId).then(() => {
      console.log('документ успешно удален')
      this.dispatch('getUserById', { userId })
    }).catch(error => {
      console.log('ошибка удаления документа', error.response)
    })
  },
  showUserEducationUpdateModal ({ commit }, education) {
    commit('SHOW_USER_EDUCATION_UPDATE_MODAL', education)
  },
  closeUserEducationUpdateModal ({ commit }) {
    commit('CLOSE_USER_EDUCATION_UPDATE_MODAL')
  },
  updateUserEducationType ({ commit }, type) {
    commit('UPDATE_USER_EDUCATION_TYPE', type)
  },
  updateUserEducationOrganization ({ commit }, organization) {
    commit('UPDATE_USER_EDUCATION_ORGANIZATION', organization)
  },
  updateUserEducationDateStart ({ commit }, date) {
    commit('UPDATE_USER_EDUCATION_DATE_START', date)
  },
  updateUserEducationDateEnd ({ commit }, date) {
    commit('UPDATE_USER_EDUCATION_DATE_END', date)
  },
  updateUserEducationSpeciality ({ commit }, speciality) {
    commit('UPDATE_USER_EDUCATION_SPECIALITY', speciality)
  },
  updateUserEducationDocument ({ commit }, document) {
    commit('UPDATE_USER_EDUCATION_DOCUMENT', document)
  },
  updateUserEducationDateAt ({ commit }, date) {
    commit('UPDATE_USER_EDUCATION_DATE_AT', date)
  },
  updateUserEducation ({ commit, state }, educationId) {
    const userId = state.userForUpdate.id
    const params = {
      id: educationId,
      updateData: {
        type_id: state.educationUpdateModal.education.type.id,
        organization: state.educationUpdateModal.education.organization,
        start_at: state.educationUpdateModal.education.start_at,
        end_at: state.educationUpdateModal.education.end_at,
        speciality_id: state.educationUpdateModal.education.speciality.id,
        document_id: state.educationUpdateModal.education.document.id,
        date_at: state.educationUpdateModal.education.date_at
      }
    }

    usersApi.putEducation(params).then(() => {
      commit('CLOSE_USER_EDUCATION_UPDATE_MODAL')
      this.dispatch('getUserById', { userId })
    }).catch(error => {
      console.log('ошибка редактирования образования', error.response)
    })
  },
  showUserEducationCreateModal ({ commit }) {
    commit('SHOW_USER_EDUCATION_CREATE_MODAL')
  },
  closeUserEducationCreateModal ({ commit }) {
    commit('CLOSE_USER_EDUCATION_CREATE_MODAL')
  },
  setUserNewEducationType ({ commit }, type) {
    commit('SET_USER_NEW_EDUCATION_TYPE', type)
  },
  setUserNewEducationOrganization ({ commit }, organization) {
    commit('SET_USER_NEW_EDUCATION_ORGANIZATION', organization)
  },
  setUserNewEducationDateStart ({ commit }, date) {
    commit('SET_USER_NEW_EDUCATION_DATE_START', date)
  },
  setUserNewEducationDateEnd ({ commit }, date) {
    commit('SET_USER_NEW_EDUCATION_DATE_END', date)
  },
  setUserNewEducationSpeciality ({ commit }, speciality) {
    commit('SET_USER_NEW_EDUCATION_SPECIALITY', speciality)
  },
  setUserNewEducationDocument ({ commit }, document) {
    commit('SET_USER_NEW_EDUCATION_DOCUMENT', document)
  },
  setUserNewEducationDateAt ({ commit }, date) {
    commit('SET_USER_NEW_EDUCATION_DATE_AT', date)
  },
  createUserEducation ({ commit, state }) {
    const userId = state.userForUpdate.id

    const postData = {
      user_id: userId,
      type_id: state.educationCreateModal.education.type.id,
      organization: state.educationCreateModal.education.organization,
      start_at: state.educationCreateModal.education.start_at,
      end_at: state.educationCreateModal.education.end_at,
      speciality_id: state.educationCreateModal.education.speciality.id,
      document_id: state.educationCreateModal.education.document.id,
      date_at: state.educationCreateModal.education.date_at
    }

    usersApi.postEducation(postData).then(() => {
      commit('CLOSE_USER_EDUCATION_CREATE_MODAL')
      this.dispatch('getUserById', { userId })
    }).catch(error => {
      console.log('ошибка создания образования', error.response)
    })
  },
  removeUserEducation ({ commit, state }, educationId) {
    const userId = state.userForUpdate.id

    usersApi.deleteEducation(educationId).then(() => {
      console.log('образование успешно удалено')
      this.dispatch('getUserById', { userId })
    }).catch(error => {
      console.log('ошибка удаления образования', error.response)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
